"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMeasureTextWidth = void 0;
var renderer_provider_1 = require("../renderer-provider");
var useMeasureTextWidth = function () {
    var measureTextWidth = (0, renderer_provider_1.useRendererContext)().measureTextWidth;
    return measureTextWidth;
};
exports.useMeasureTextWidth = useMeasureTextWidth;
